import React from "react";
import { EnquiryList } from "./subPages/EnquiryList";
import { useEnquiryContext } from "./context";
import { enquiryOperationsList } from "./constants/enquiry.constants";
import { AddEnquiry } from "./subPages/NewEnquiry";
import { PreviewEnquiry } from "./subPages/PreviewEnquiry";
import { UpdateEnquiry } from "./subPages/UpdateEnquiry";
import { EnquiryTask } from "./subPages/EnquiryTask";

export const EnquiryPage = () => {
  const { currentOperationPage } = useEnquiryContext();

  return (
    <>
      {currentOperationPage === enquiryOperationsList.listEnquiry && (
        <EnquiryList />
      )}
      {currentOperationPage === enquiryOperationsList.newEnquiry && (
        <AddEnquiry />
      )}
      {currentOperationPage === enquiryOperationsList.previewEnquiry && (
        <PreviewEnquiry />
      )}
      {currentOperationPage === enquiryOperationsList.updateEnquiry && (
        <UpdateEnquiry />
      )}
      {currentOperationPage === enquiryOperationsList.enquiryTask && (
        <EnquiryTask />
      )}
    </>
  );
};
